export class AvatarLiveError extends Error {
  constructor(
    readonly code: string,
    message: string,
    readonly fatal = false,
  ) {
    super(message);
    this.name = 'AvatarLiveError';
  }
}
